import { UploadedAttachments } from "../Attachment";
import { IDifferenceFromAgreement, IMonitoringApprovalHistory, MyType, NestedKeys } from "../monitoringFields";
import { IMonitoringAgreementCgsModel } from "../models/monitoring_agreement_cgs.interface";
import { IUser } from "../models/user.interface";
import { ApplicationStatus, monitoringStatus } from "../enums";
import { IMountainousSettlement } from "../models/mountainous_settlement.interface";

export type ApiCgsListResponse = {
  results: IMonitoringCgsFields & Partial<IMonitoringAgreementCgsModel>[];
  total: number;
  page: number;
  pages: number;
};

export enum Type {
  monitoring = "monitoring",
  agreement = "agreement",
  approved = "approved",
}

export type Filter = {
  company_name: string;
  company_identification_code: string;
  page: number;
  amountOnPage: number;
  type: Type;
  municipality: string;
  component: string;
  is_monitorable?: boolean;
  is_deadline_approve?: boolean;
  monitoring_approval_status?: monitoringStatus | string;
  is_paid?: boolean;
  // is_monitoring_deadline?: Date | null;
};

export type ApplicationPreview = {
  _id: string;
  id: number;
  company_name: string;
  company_identification_code: string;
  contract_number: string;
  loan_id: string;
  approved_amount: number;
  contract_signed_date: string;
  program_component: string;
  component: string;
  monitoring_approval?: boolean;
  actual_municipality?: string | IMountainousSettlement;
  contract?: string;
  created_by?: IUser;
  monitoring_approval_history?: IMonitoringApprovalHistory[];
  monitoring_deadline?: Date | null;
  monitoring_approval_status?: ApplicationStatus;
  monitoring_new_deadline?: Date | null;
  is_deadline_approve?: boolean;
  is_monitoring_deadline?: "";
  is_monitorable: boolean;
  is_paid?: boolean;
};
export interface IMonitoringCgsFields {
  _id?: string;
  contract?: string;
  contract_signed_date: Date | null;
  //used_amount
  used_amount?: number;
  targeted_used_amount?: number;
  nontargeted_used_amount?: number;
  unfulfilled_used_amount_reason?: string;
  unfulfilled_used_amount_month_day?: number;
  unfulfilled_used_amount_recommendation_reason?: string;
  is_fullfilled_used_amount?: boolean;
  is_loan_documentation_provided?: boolean;
  is_deadline_approve?: boolean;
  monitoring_new_deadline?: Date | null;
  is_new_deadline_approved?: boolean;
  //fixed_assets_capital_expenditures
  fixed_assets_capital_expenditures?: number;
  targeted_fixed_assets_capital_expenditures?: number;
  nontargeted_fixed_assets_capital_expenditures?: number;
  //machine_equipment_equipment
  machine_equipment_equipment?: number;
  targeted_machine_equipment_equipment?: number;
  nontargeted_machine_equipment_equipment?: number;
  //vehicles_special_technic
  vehicles_special_technic?: number;
  targeted_vehicles_special_technic?: number;
  nontargeted_vehicles_special_technic?: number;
  //purchase_building_land
  purchase_building_land?: number;
  targeted_purchase_building_land?: number;
  nontargeted_purchase_building_land?: number;
  //building_repairs
  building_repairs?: number;
  targeted_building_repairs?: number;
  nontargeted_building_repairs?: number;
  //funds_turnover
  funds_turnover?: number;
  targeted_funds_turnover?: number;
  nontargeted_funds_turnover?: number;
  /////////////////////////////////

  is_project_activities_checked?: boolean;
  project_activities_comment?: string;
  is_purchased_activities_checked?: boolean;
  purchased_activities_comment?: string;
  is_female_entrepreneur_checked?: boolean;
  female_entrepreneur_comment?: string;
  is_mountain_region_checked?: boolean;
  mountain_region_comment?: string;
  is_income_to_k_checked?: boolean;
  income_to_k_comment?: string;
  is_sun_gate_beneficiary_checked?: boolean;
  sun_gate_beneficiary_comment?: string;
  is_purpose_detailed_provided?: boolean;
  purpose_detailed_comment?: string;
  additional_comments?: string;
  representative_id_number?: string;
  representative_position?: string;
  monitoring_approval?: boolean;
  is_taken_business_loan_leasing?: boolean;
  difference_from_agreement?: IDifferenceFromAgreement[];
  attached_documents?: UploadedAttachments;
  monitoring_approval_history?: IMonitoringApprovalHistory[];
  monitoring_approval_status?: string;
  monitoring_approval_deadline_comment?: string;
  monitoring_deadline_comment?: string;
  mountainous_settlement?: string | IMountainousSettlement;
  created_by?: IUser;
  is_paid?: boolean;
}

export interface ApproveData {
  _id: string;
  unfulfilled_used_amount_month_day?: number;
  monitoring_new_deadline?: Date | null;
  monitoring_deadline_comment?: string;
  is_deadline_approve?: boolean;
  contract_signed_date?: Date | null;
}

export type MonitoringCgsFieldsKeys = NestedKeys<IMonitoringCgsFields>;
export type MonitoringAgreementCgsModelKeys = NestedKeys<IMonitoringAgreementCgsModel>;
